import React from "react";

interface AgreementInfoColumnProps <T> {
  title?: string; 
  value?: T;
  fixedWidth?: boolean
  valueFieldSize?: FieldSize;
  titleFieldSize?: FieldSize;
}

export enum FieldSize {
  SM = "sm",
  LG = "lg"
}
export function AgreementInfoColumn<T>({
  title, 
  value, 
  fixedWidth = true, 
  valueFieldSize = FieldSize.SM, 
  titleFieldSize = FieldSize.SM
} : AgreementInfoColumnProps<T> ){

  if(!title || !value)
    return <div className="table__column"/>

  return (
    <div className="table__column">
        <span className={`field-${titleFieldSize} text-gray-700 mr-1`}>{title}</span>
        <strong className={`${fixedWidth ? "field-" + valueFieldSize : ""} u-fs-16`}>{value}</strong>
    </div>
  )
}